/** Parses backend cookie consent response: null | true | false. */
export function parseStoredUserCookieChoice(raw: boolean | null | undefined): {
  hasStoredChoice: boolean;
  permitted: boolean;
} {
  if (raw == null) {
    return { hasStoredChoice: false, permitted: false };
  }

  return { hasStoredChoice: true, permitted: raw };
}
